import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ResultadoTcPage } from './resultado-tc';
import { ComponentsModule } from '../../../components/components.module'
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
@NgModule({
  declarations: [
    ResultadoTcPage,
  ],
  imports: [
    IonicPageModule.forChild(ResultadoTcPage),
    ComponentsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class ResultadoTcPageModule {}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/resultado-tc/resultado-tc.module.ts